module.exports = __webpack_public_path__ + "static/media/purpura.f784cf29.jpg";